import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';

export type SinglePaymentInvoiceType = {
  id: string;
  date_created: string;
  error_code: string;
  error_message: string;
  final_amount: number;
  quantity: number;
  status: 'failed' | 'paid';
  stripe_invoice_url: string;
};

export const getSinglePaymentInvoicesApi = (
  params: ApiParams
): Promise<ApiResponseType<ListResponseType<SinglePaymentInvoiceType>>> => {
  const uri = '/billing/payment_invoices/';

  return authApiService.GET(uri, params);
};
